import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import whitecross from "../assets/images/icons/whitecross.svg";
import { fetchCurrentTripForm, updateCategory } from '../redux/features/tripFormSlice';

export default function CategoryBtns() {
  const tripFormData = useSelector(fetchCurrentTripForm)
  const [buttonOn, setButtonOn] = useState([...tripFormData.category]);
  const [categoryChanged, setcategoryChanged] = useState(false);
  const categoryRef = useRef(null)
  const dispatch = useDispatch();

  useEffect(() => {
    if(categoryChanged) {
      categoryRef.current?.scrollIntoView()
      setcategoryChanged(false);
    }
  });
  
 const handleChange = (num) => {
    setcategoryChanged(true)
    const isSelected = checkItSelected(num)
    if (isSelected) {
      const selectedCategory = buttonOn.filter(category => category != num)
      setButtonOn(selectedCategory);
    }
    else {
      buttonOn.push(num)
      setButtonOn(buttonOn)
    }

    dispatch(updateCategory(buttonOn));

   
  }

  const checkItSelected = (value) => {
    return buttonOn.find(el => el === value)
  }
 
  return (
    <div className='category-btns' ref={categoryRef} >
      <div className='category-btn_top'>
        <button className={checkItSelected(1) ? "category-btn-active" : "category-btn"}
          onClick={() => handleChange(1)}>
            
            <div className="category">
            <div>
            Adventure
            </div>
            <div>
            {checkItSelected(1) ? <img
            
            className="white-cross"
            src={whitecross}
            alt="whitecross"
          />: ""}
          </div>
          </div>
          </button>
        <button className={checkItSelected(2) ? "category-btn-active" : "category-btn"}
          onClick={() => handleChange(2)}>
          <div className="category">
            <div>
            Family trip
            </div>
            <div>
            {checkItSelected(2) ? <img
            className="white-cross"
            src={whitecross}
            alt="whitecross"
          />: ""}
          </div>
          </div>
          </button>
        <button className={checkItSelected(3) ? "category-btn-active" : "category-btn"}
          onClick={() => handleChange(3)}>
          <div className="category">
            <div>
            Romance
            </div>
            <div>
            {checkItSelected(3) ? <img
            
            className="white-cross"
            src={whitecross}
            alt="whitecross"
          />: ""}
          </div>
          </div>
          </button>
      </div>
      <div className='category-btn_bottom'>
        <button className={checkItSelected(4) ? "category-btn-active" : "category-btn"}
          onClick={() => handleChange(4)}>
          <div className="category">
            <div>
            Couple friendly
            </div>
            <div>
            {checkItSelected(4) ? <img
            
            className="white-cross"
            src={whitecross}
            alt="whitecross"
          />: ""}
          </div>
          </div>
          </button>
      </div>
    </div>
  )
}